import * as React from 'react';

import './style.scss';



export interface IleftBg {
  visible?: any;
  backgroundImage: string;
}

export const LeftBg: React.FC<IleftBg> = ({ visible, backgroundImage }): JSX.Element => {
  return (
    <div className="leftBg">
      {backgroundImage &&
        <img src={backgroundImage} />
      }
    </div>
  );
};